// With the default font size on desktops, 62.5%, 1rem = 10px

export const PHONE_MAX_WIDTH_IN_PX = 768;
export const TABLET_MAX_WIDTH_IN_PX = 1024;

export const theme = {
  global: {
    desktop: {
      fontSize: '62.5%',
      gridColumnWidth: '128px',
      gridColumnGap: '48px',
      gridColumSpacing: '1fr',
    },
    laptop: {
      maxWidth: '1444px',
      fontSize: '55%',
      gridColumnWidth: '130px',
      gridColumnGap: '30px',
      gridColumSpacing: '1fr',
    },
    tablet: {
      maxWidth: `${TABLET_MAX_WIDTH_IN_PX}px`,
      fontSize: '45%',
      gridColumnWidth: '60px',
      gridColumnGap: '24px',
      gridColumSpacing: '1fr',
    },
    phone: {
      maxWidth: `${PHONE_MAX_WIDTH_IN_PX}px`,
      fontSize: '40%',
      gridColumnWidth: '1fr',
      gridColumnGap: '12px',
      gridColumSpacing: '4px',
      negativeXMargin: '-16px',
    },
  },
  colors: {
    background: '#000000',
    primary: '#FFFFFF',
    secondary: 'rgba(255, 255, 255, 0.3)',
    accent: '#0279e8',
  },
  spacing: {
    xs: 4,
    s: 8,
    m: 16,
    l: 24,
    xl: 48,
    xxl: 96,
  },
  typography: {
    font: {
      default: 'Helvetica Neue, sans-serif',
    },
    fontWeight: {
      regular: 400,
      semibold: 500,
      bold: 600,
    },
    fontSize: {
      extrasmall: '1.4rem',
      mediumsmall: '1.7rem',
      small: '1.9rem',
      medium: '2.4rem',
      large: '3.2rem',
      extralarge: '6.4rem',
      xxlarge: '9.1rem',
      ultralarge: '12.5rem',
    },
  },

  // = = = = = V2 = = = = =
  globalV2: {
    xs: {
      minWidth: '400px',
      maxWidth: '576px',
      gridColumnWidth: '1fr',
      gridColumnGap: '8px',
      gridColumSpacing: '4px',
    },
    sm: {
      minWidth: '576px',
      maxWidth: '768px',
      gridColumnWidth: '1fr',
      gridColumnGap: '12px',
      gridColumSpacing: '4px',
    },
    md: {
      minWidth: '768px',
      maxWidth: '992px',
      gridColumnWidth: '1fr',
      gridColumnGap: '24px',
      gridColumSpacing: '1fr',
    },
    md_alt: {
      minWidth: '768px',
      maxWidth: '1024px',
      gridColumnWidth: '1fr',
      gridColumnGap: '24px',
      gridColumSpacing: '1fr',
    },
    lg: {
      minWidth: '992px',
      maxWidth: '1200px',
      gridColumnWidth: '1fr',
      gridColumnGap: '30px',
      gridColumSpacing: '1fr',
    },
    xl: {
      minWidth: '1200px',
      maxWidth: '1400px',
      gridColumnWidth: '1fr',
      gridColumnGap: '36px',
      gridColumSpacing: '1fr',
    },
    xxl: {
      minWidth: '1400px',
      gridColumnWidth: '1fr',
      gridColumnGap: '48px',
      gridColumSpacing: '1fr',
    },
    xxxl: {
      minWidth: '2100px',
      maxWidth: '2500px',
      gridColumnWidth: '1fr',
      gridColumnGap: '48px',
      gridColumSpacing: '1fr',
    },
  },
  colorsV2: {
    primary: '#000000',
    secondary: 'rgba(0,0,0,0.6)',
    background: '#ffffff',
    accent: 'rgba(5, 255, 0, 1)',
    primaryBlue: 'rgb(0, 127, 245)',
  },
  typographyV2: {
    font: {
      default: 'var(--font-geist-sans), system-ui, sans-serif',
      helvetica: 'var(--font-helvetica-neue), Helvetica, sans-serif',
      playfair: 'var(--font-playfair), serif',
      spaceGrotesk: 'var(--font-space-grotesk), system-ui, sans-serif',
    },
    fontWeight: {
      regular: 400,
      semibold: 500,
      bold: 600,
    },
    fontSize: {
      extrasmall: '1.4rem',
      mediumsmall: '1.6rem',
      small: '1.9rem',
      medium: '2.4rem',
      large: '3.2rem',
      extralarge: '4.8rem',
      xlarge: '7.2rem',
      xxlarge: '9.6rem',
      ultralarge: '12.5rem',
    },
  },
} as const;

export type Theme = typeof theme;
